import styled from "styled-components";
import PhoneInputLib from 'react-phone-number-input';

export const StyledPhoneInput = styled(PhoneInputLib)`
  width: 100%;
  font-family: Gilroy;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${props => props.theme.palette.colors.inputSurface};
  margin-top: 16px;
  padding: 0 8px;
  border-radius: 14px;
  border: 1px solid ${props => props.theme.palette.colors.inputBorder};
  color: ${props => props.theme.palette.colors.text};
  box-shadow: inset 0 1px 0 ${props => props.theme.palette.colors.borderSoft};
  transition: border-color 0.22s ease, box-shadow 0.22s ease, background-color 0.22s ease;

  &:hover {
    border-color: ${props => props.theme.palette.colors.borderStrong};
  }

  &:focus-within {
    border-color: ${props => props.theme.palette.blue.main};
    box-shadow: 0 0 0 4px ${props => props.theme.palette.colors.badgeMuted};
  }

  .PhoneInputCountry {
    margin-right: 4px;
    color: ${props => props.theme.palette.colors.text};
  }

  .PhoneInputCountrySelectArrow {
    opacity: 1;
    color: ${props => props.theme.palette.colors.subdued};
  }

  .PhoneInputInput {
    width: 100%;
    border: none;
    background: transparent;
    height: 48px;
    padding: 12px 8px 12px 4px;
    outline: none;
    box-shadow: none;
    color: ${props => props.theme.palette.colors.text};

    &::placeholder {
      color: ${props => props.theme.palette.colors.subdued};
      opacity: 1;
    }
  }
`;
